import filter from 'lodash/fp/filter'

// noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByVariantId: (state, getters) => variantId => {
        return filter({ variant: variantId })(getters['all'])
    },

    byId: state => id => {
        return state.entities[id]
    },

}
